import script from "./AddressUpdate.vue?vue&type=script&setup=true&lang=js"
export * from "./AddressUpdate.vue?vue&type=script&setup=true&lang=js"

import "./AddressUpdate.vue?vue&type=style&index=0&id=62a4e350&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62a4e350"]])

export default __exports__